import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react";

import { TeamMember } from "@/jenesys-types/jenesys-entities/config";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  handleResendInvite: () => void;
  isLoading: boolean;
  selectedMember: TeamMember;
}

export const ResendInviteModal = ({
  isOpen,
  isLoading,
  onClose,
  handleResendInvite,
  selectedMember
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    size="xl"
    closeOnOverlayClick={false}
  >
    <ModalOverlay />
    <ModalContent rounded={16} px={4} py={4}>
      <ModalHeader pb={2} fontSize={20} color="secondary.600">
        Resend WhatsApp Invite
      </ModalHeader>
      <ModalCloseButton top={7} right={8} />
      <ModalBody pt={0}>
        <Text fontWeight={500} fontSize={14}>
          Would you like to resend the WhatsApp QR code email to{" "}
          {selectedMember?.user.email}? This will invalidate any previous link
          and generate a new one.
        </Text>
      </ModalBody>
      <ModalFooter as={HStack} justifyContent="left">
        <Button h={12} variant="outline" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          w={143}
          h={12}
          size="sm"
          onClick={handleResendInvite}
          isLoading={isLoading}
          loadingText="Resending..."
        >
          Resend Now
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
